var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIdCard({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "nonzero",
    d: "M22 4a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h20zM8.086 12.508H5.005c-.826 0-1.581.543-1.952 1.402l-.824 1.925a.58.58 0 0 0 .017.494c.08.15.22.242.371.242h7.857a.427.427 0 0 0 .37-.242.58.58 0 0 0 .018-.494l-.825-1.925c-.37-.86-1.125-1.402-1.95-1.402zm13.232 1.778H12.5a.5.5 0 0 0-.5.5v.143a.5.5 0 0 0 .5.5h8.818a.5.5 0 0 0 .5-.5v-.143a.5.5 0 0 0-.5-.5zm0-2.286H12.5a.5.5 0 0 0-.5.5v.143a.5.5 0 0 0 .5.5h8.818a.5.5 0 0 0 .5-.5V12.5a.5.5 0 0 0-.5-.5zM6.545 7.429c-1.338 0-2.424 1.137-2.424 2.54 0 1.402 1.086 2.539 2.424 2.539 1.34 0 2.425-1.137 2.425-2.54 0-1.402-1.086-2.54-2.425-2.54zm14.773 2.285H12.5a.5.5 0 0 0-.5.5v.143a.5.5 0 0 0 .5.5h8.818a.5.5 0 0 0 .5-.5v-.143a.5.5 0 0 0-.5-.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdCard);
export default __webpack_public_path__ + "static/media/id-card.4bd24385.svg";
export { ForwardRef as ReactComponent };